import Axios from 'axios';

import env from '../environment/environment';

const Api = Axios.create({
  baseURL: env.url
});

export default Api
